<div class="container-fluid">
	<app-alert-line [alertLineData]="alertLineData"></app-alert-line>

	<div class="row">
		<div class="col-12">
			<h2>Mon mot de passe</h2>
	
			<div class="form-group">
				<label class="ls-label-strong">Nouveau mot de passe</label><br>
				<p-password [(ngModel)]="password1" [toggleMask]="true" promptLabel="Saisissez votre mot de passe" weakLabel="Faible" mediumLabel="Moyen" strongLabel="Fort"></p-password>
			</div>

			<div class="form-group">
				<label class="ls-label-strong">Saisissez à nouveau votre mot de passe</label><br>
				<p-password [(ngModel)]="password2" [toggleMask]="true" promptLable="Confirmez votre mot de passe" weakLabel="Faible" mediumLabel="Moyen" stringLabel="Fort"></p-password>
			</div>
		</div>
	</div>

	<div class="row">
		<div class="col-12">
			<br>
			<button matTooltip="Enregister" mat-raised-button type="button" class="btn btn-primary material-item" (click)="doSave()"><i class="material-icons md-24 icons">done</i> Enregistrer</button>
		</div>
	</div>

</div>
